import { envTypeGet } from "../common";
import { API_TYPES } from "./api_constants";

export type UrlBases = {
  auth: string;
  citajteo: string;
};

export type ApiType = "auth" | "citajteo";

export const apiUrlBasesGet = (): UrlBases => {
  const envType = envTypeGet();
  let urlBases = {
    auth: "http://localhost:3002/api/v1",
    citajteo: "http://localhost:3011/api/v1",
  };
  if (envType === "production") {
    urlBases = {
      auth: "https://citajteo.rs/api/auth-citajteo/v1",
      citajteo: "https://citajteo.rs/api/citajteo/v1",
    };
  } else if (envType === "staging") {
    urlBases = {
      auth: "https://citajteo.emlearn.info/api/auth-citajteo/v1",
      citajteo: "https://citajteo.emlearn.info/api/v1",
    };
  }

  return urlBases;
};

export const apiTypeUrlBaseGet = (apiType: string): string => {
  const urlBases: UrlBases = apiUrlBasesGet();
  const url = urlBases[apiType as ApiType];
  return url;
};

export const apiTypeUrlGet = (apiType: string, path: string): string => {
  const urlBase: string = apiTypeUrlBaseGet(apiType);
  const url = urlBase + "/" + path;
  return url;
};

export const apiAuthUrlGet = (path: string = ""): string => {
  const url: string = apiTypeUrlGet(API_TYPES.AUTH, path);
  return url;
};

export const apiCitajteoUrlGet = (path: string = ""): string => {
  const url: string = apiTypeUrlGet(API_TYPES.CITAJTEO, path);
  return url;
};
